export default __webpack_public_path__ + "static/media/banner-transferencia--.333d8686.jpg";